import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/medium': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M0 32h448v448h-448v-448zM372.2 138.1v-5h-83.2l-59.3 147.9-67.4-148h-87.3v5.1l28.1 33.9c2.8 2.5 4.2 6.1 3.8 9.8v133c0.8 4.8-0.7 9.7-4.1 13.2l-31.6 38.3v5.1h89.8v-5.1l-31.6-38.3c-3.4-3.5-5.1-8.4-4.4-13.2v-115l78.7 171.6h9.1l67.6-171.6v136.9c0 3.6 0 4.3-2.4 6.7l-24.3 23.6v4.9h118v-5.1l-23.5-23c-2.1-1.5-3.1-4.1-2.7-6.7v-169.3c-0.4-2.5 0.6-5.1 2.7-6.7z'
      }
    ]
  }
})
